import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getProfile() {
  return axios.get('/ajax/profile')
}

export function updateProfile(data) {
  return axios.put('/ajax/profiles/update', data)
}

export function updatePassword(data) {
  return axios.put('/ajax/profiles/update_password', data)
}

export function getTimezones() {
  return axios.get('/ajax/profiles/timezones')
}

export function getCurrentTimezone() {
  return axios.get('/ajax/profiles/current_timezone')
}

export function updateTimezone(timezone) {
  return axios.put('/ajax/profiles/timezone', { timezone })
}

export function getNotificationSettings() {
  return axios.get('/ajax/profiles/notification_settings')
}

export function uploadAvatar(formData, opts = {}) {
  return axios.post('/ajax/profiles/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...opts
  })
}

export function getAvatar() {
  return axios.get('/ajax/profiles/avatar')
}
